import ObserverAutoComplete from './AutoComplete';
export default ObserverAutoComplete;
